import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BookingFlowComponent } from './components/booking-flow/booking-flow.component';
import { AddServiceComponent } from './components/booking-steps/add-service/add-service.component';
import { EnterYourInformationComponent } from './components/booking-steps/enter-your-information/enter-your-information.component';
import { PetInformationComponent } from './components/booking-steps/pet-information/pet-information.component';
import { PetListComponent } from './components/booking-steps/pet-list/pet-list.component';
import { ReviewRequestComponent } from './components/booking-steps/review-request/review-request.component';
import { SelectDateTimeComponent } from './components/booking-steps/select-date-time/select-date-time.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { ErrorComponent } from './components/error/error.component';
import { BaseRouteGuard } from './guards/baseRoute.guard';
import { PathValidationGuard } from './guards/pathValidation.guard';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'booking/service',
        pathMatch: 'full',
    },
    {
        path: 'booking',
        component: BookingFlowComponent,
        canActivate: [BaseRouteGuard],
        children: [
            {
                path: 'service',
                component: AddServiceComponent,
            },
            {
                path: 'employee',
                redirectTo: 'booking/service',
            },
            {
                path: 'datetime',
                component: SelectDateTimeComponent,
                canActivate: [PathValidationGuard],
                data: {
                    pathValidationList: ['service'],
                },
            },
            {
                path: 'client',
                component: EnterYourInformationComponent,
                canActivate: [PathValidationGuard],
                data: {
                    pathValidationList: ['service', 'employee', 'datetime'],
                },
            },
            {
                path: 'pet-list',
                component: PetListComponent,
                canActivate: [PathValidationGuard],
                data: {
                    pathValidationList: ['service', 'employee', 'datetime', 'client'],
                },
            },
            {
                path: 'pet-information',
                component: PetInformationComponent,
                canActivate: [PathValidationGuard],
                data: {
                    pathValidationList: ['service', 'employee', 'datetime', 'client'],
                },
            },
            {
                path: 'review',
                component: ReviewRequestComponent,
                canActivate: [PathValidationGuard],
                data: {
                    pathValidationList: ['service,', 'employee', 'datetime'],
                },
            },
        ],
    },
    {
        path: 'booking/submitted',
        component: ConfirmationComponent,
        canActivate: [PathValidationGuard],
        data: {
            pathValidationList: ['service,', 'employee', 'datetime', 'client'],
        },
    },
    {
        path: 'booking/error',
        component: ErrorComponent,
    },
    {
        path: 'booking/invalid',
        component: ErrorComponent,
    },
    {
        path: 'booking/incorrectTime',
        component: ErrorComponent,
    },
    {
        path: '**',
        redirectTo: 'booking/service',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule],
    providers: [BaseRouteGuard],
})
export class AppRoutingModule {}
